import Autosuggest, { Props as AutosuggestProps } from "components/Autosuggest"
import { useCallback, useMemo } from "react"

import { ComponentProps } from "."
import { Wrapper } from "./styled"

const TMDBSearchDropdown = ({
  disabled,
  hasSelectedIcon,
  label = "Search TMDB",
  selected,
  onSelect,
  type = "both",
  suggestions: suggestionsProp,
  loading,
  onSearch
}: ComponentProps) => {
  const handleGetSuggestions: AutosuggestProps["onGetSuggestions"] =
    useCallback(
      ({ inputValue }) => {
        if (onSearch) {
          onSearch(inputValue)
        }
      },
      [onSearch]
    )

  const suggestions = useMemo(
    () =>
      suggestionsProp?.map((item) => ({
        id: item.id.toString(),
        name: `${item.title} (${item.year})`,
        year: item.year,
        mediaType: item.mediaType,
        overview: item.overview,
        externalIds: item.externalIds,
        images: item.poster
          ? [
              {
                alternativeText: `${item.title} poster`,
                filename: `tmdb-${item.id}.jpg`,
                formats: [],
                height: 60,
                url: item.poster,
                width: 40
              }
            ]
          : undefined
      })),
    [suggestionsProp]
  )

  return (
    <Wrapper>
      <Autosuggest
        disabled={disabled}
        hasSelectedIcon={hasSelectedIcon}
        inputId="tmdb-search"
        isLoading={loading}
        label={label}
        name={label}
        onGetSuggestions={handleGetSuggestions}
        onSuggestionClick={onSelect}
        suggestions={suggestions}
        value={selected}
      />
    </Wrapper>
  )
}

export default TMDBSearchDropdown
